import React from "react";

const TabButton: React.FC<{
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  count?: number;
  "data-tab"?: string;
}> = ({ active, onClick, children, count, "data-tab": dataTab }) => (
  <button
    onClick={onClick}
    data-tab={dataTab}
    className={`whitespace-nowrap px-3 py-1.5 text-sm font-medium border-b-2 transition-colors ${
      active
        ? "border-[#00A89D] text-[#00A89D]"
        : "border-transparent text-gray-500 hover:text-gray-700"
    }`}
  >
    {children}
    {count !== undefined && count > 0 && (
      <span className="ml-1 px-1 py-0.5 text-xs rounded-full bg-gray-200 text-gray-600">
        {count}
      </span>
    )}
  </button>
);

export default TabButton;
